import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import * as actions from '../../store/actions';
import { toastr } from 'react-redux-toastr'
import { i18n } from '../../translate/i18n';

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  }
}

export const authSuccess = (id, name, selectedAccess, access, superadmin, email, photo = null) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    id,
    name,
    selectedAccess,
    access,
    superadmin,
    email,
    photo,
  }
}

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error
  }
}

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('selectedTenant');
  return {
    type: actionTypes.AUTH_LOGOUT
  }
}


export const selectAccess = (tenant) => {
  return {
    type: actionTypes.AUTH_SELECT_TENANT,
    tenant: tenant
  }
}

export const selectTenantAccess = (tenant) => {
  return dispatch => dispatch(selectAccess(tenant));
}

export const auth = (email, password) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(authStart());
      const authData = {
        email,
        password
      }

      API.post('users/loginweb', authData)
        .then(res => {
          let tenant = null;
          let access = [];
          let selectedAccess = null;
          if (res.data.access.length > 0) {
            access = res.data.access

            if (access.length > 1) {
              //precisa selecionar qual tenant, redirecinar pra pagina de selecao de tenant
            } else {
              tenant = res.data.access[0].tenant._id;
              localStorage.setItem('selectedTenant', tenant);
              selectedAccess = res.data.access[0]

            }

            localStorage.setItem('token', res.data.token);
          }
          dispatch(authSuccess(res.data.id, res.data.name, selectedAccess, access, res.data.superadmin, res.data.email, res.data.photo))
          dispatch(actions.getUserAction({ id: res.data.id, name: res.data.name }))
          resolve(res.data);
        })
        .catch(err => {
          console.log(err)
          dispatch(authFail(err.response ? err.response.data.error : err))
          reject(err);
        })
    })

  }
}

export const setAuthRedirectPath = (path) => {
  return {
    type: actionTypes.SET_AUTH_REDIRECT_PATH,
    path: path
  }
}

export const getMe = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(authStart());
      API.get('users/me')
        .then(res => {
          let selectedAccess = null;
          let tenant = null;
          const selectedTenant = localStorage.getItem('selectedTenant');
          let access = res.data.access
          if (selectedTenant) {
            if (res.data.access.length > 0) {
              tenant = selectedTenant;
              const tenantIndex = res.data.access.findIndex(ac => ac.tenant._id === tenant)
              selectedAccess = res.data.access[tenantIndex];
            }
          } else {

            if (access.length > 1) {
              //precisa selecionar qual tenant, redirecinar pra pagina de selecao de tenant
            } else {
              tenant = res.data.access[0].tenant;
              selectedAccess = res.data.access[0]
              localStorage.setItem('selectedTenant', tenant);
            }
          }

          dispatch(authSuccess(res.data._id, res.data.name, selectedAccess, access, res.data.superadmin, res.data.email, res.data.photo))
          dispatch(actions.getUserAction({ id: res.data._id, name: res.data.name }))
          resolve(res.data);
        })
        .catch(err => {
          dispatch(authFail(err.response))
          resolve('error');
        })
    })
  }
}


export const changeNameSuccess = (data) => {
  return {
    type: actionTypes.AUTH_CHANGE_NAME_SUCCESS,
    name: data.name
  }
}

export const changeReceiveAutomaticEmailsSuccess = (data) => {
  return {
    type: actionTypes.AUTH_CHANGE_RECEIVE_AUTOMATIC_EMAILS_SUCCESS,
    ...data,
  }
}

export const changeShowServiceReportCoordinatesSuccess = (data) => {
  return {
    type: actionTypes.AUTH_CHANGE_SHOW_SERVICE_REPORT_COORDINATES_SUCCESS,
    ...data,
  }
}

export const changeProfilePictureSuccess = (data) => {
  return {
    type: actionTypes.AUTH_CHANGE_PROFILE_PICTURE_SUCCESS,
    photo: data.photo,
  }
}

export const changePasswordSuccess = () => {
  return {
    type: actionTypes.AUTH_CHANGE_PASSWORD_SUCCESS,
  }
}

export const changeName = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(authStart());
      API.post('/users/changename', body)
        .then(res => {
          dispatch(changeNameSuccess(res.data));
          toastr.success(i18n.t('changeNameStr.toastr'), `${i18n.t('changeNameStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(authFail(err));
          console.log('err', err);
          toastr.error('Erro', err.response.message)
          resolve('error');
        });
    })
  }
}

export const changePassword = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(authStart());
      API.post('/users/changepassword', body)
        .then(res => {
          dispatch(changePasswordSuccess());
          toastr.success(i18n.t('changePasswordStr.toastr'), `${i18n.t('changePasswordStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(authFail(err));
          if (err.response.data.message === "Wrong Password") {
            toastr.error(i18n.t('changePasswordStr.toastrError'), i18n.t('changePasswordStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.message)
          }
          resolve('error');
        });
    })
  }
}

export const changeProfilePicture = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(authStart());
      API.post('/users/changepicture', body)
        .then(res => {
          dispatch(changeProfilePictureSuccess(res.data));
          toastr.success(i18n.t('changeProfilePictureStr.toastr'), `${i18n.t('changeProfilePictureStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(authFail(err));
          console.log('err', err);
          toastr.error('Erro', err.response.message)
          resolve('error');
        });
    })
  }
}

export const changeAutomaticEmails = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(authStart());
      API.post('/users/changeautomaticemails', body)
        .then(res => {
          const selectedTenant = localStorage.getItem('selectedTenant');
          dispatch(changeReceiveAutomaticEmailsSuccess({ selectedTenant, receiveAutomaticEmails: body.receiveAutomaticEmails }));
          toastr.success(i18n.t('changeAutomaticEmailsStr.toastr'))
          resolve('success');
        })
        .catch(err => {
          dispatch(authFail(err));
          toastr.error('Erro', err.response.message)
          resolve('error');
        });
    })
  }
}

export const changeShowServiceReportCoordinates = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(authStart());
      API.patch('/users/changeshowservicereportcoordinates', body)
        .then(res => {
          const selectedTenant = localStorage.getItem('selectedTenant');
          dispatch(changeShowServiceReportCoordinatesSuccess({ selectedTenant, showServiceReportCoordinates: body.showServiceReportCoordinates }));
          toastr.success(i18n.t('changeAutomaticEmailsStr.toastr'))
          resolve('success');
        })
        .catch(err => {
          dispatch(authFail(err));
          toastr.error('Erro', err.response.message)
          resolve('error');
        });
    })
  }
}
